'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, Database, Link2, PlugZap, ReceiptText } from 'lucide-react';
import { useLandingLanguage } from '@/hooks/useLandingLanguage';
import { Container, MotionBlock, PrimaryButton, SecondaryButton } from './shared';
export function PartnersPromoSection() {
  const $ = _c(33);
  const {
    language
  } = useLandingLanguage();
  const isEn = language === "en";
  const title = isEn ? "Already have your own system, but no ERV integration?" : "Ve\u0107 imate svoj sistem, ali nemate Evidenciju Radnog Vremena i kontrolu pristupa?";
  const subtitle = isEn ? "Connect accounting software, ERP, or your internal app with Cadrino ERV without duplicate data entry." : "Pove\u017Eite knjigovodstveni softver, ERP ili interno re\u0161enje sa Cadrino ERV bez duplog unosa podataka.";
  let t0;
  if ($[0] !== isEn) {
    t0 = isEn ? [{
      icon: Link2,
      label: "API and export models"
    }, {
      icon: PlugZap,
      label: "Fast pilot integration"
    }, {
      icon: ReceiptText,
      label: "Payroll-ready data"
    }] : [{
      icon: Link2,
      label: "API i eksport modeli"
    }, {
      icon: PlugZap,
      label: "Brz pilot integracije"
    }, {
      icon: ReceiptText,
      label: "Podaci spremni za obra\u010Dun"
    }];
    $[0] = isEn;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const chips = t0;
  const flowTitle = isEn ? "How integration works in practice" : "Kako integracija radi u praksi";
  let t1;
  if ($[2] !== isEn) {
    t1 = isEn ? ["ERV events", "Mapping and validation", "Your system output"] : ["ERV doga\u0111aji", "Mapiranje i validacija", "Izlaz u va\u0161 sistem"];
    $[2] = isEn;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const flowSteps = t1;
  const outcomeLine = isEn ? "Typical first pilot: 5-10 business days, depending on model and scope." : "Tipi\u010Dan prvi pilot: 5-10 radnih dana, u zavisnosti od modela i obima.";
  let t2;
  if ($[4] !== title) {
    t2 = <h3 className="max-w-3xl text-2xl font-semibold leading-tight text-slate-100 sm:text-3xl">{title}</h3>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== subtitle) {
    t3 = <p className="mt-3 max-w-3xl text-base leading-relaxed text-cadrino-muted">{subtitle}</p>;
    $[6] = subtitle;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = isEn ? "For software partners" : "Za softverske partnere";
  let t5;
  if ($[8] !== t4) {
    t5 = <PrimaryButton href="/partners">{t4}</PrimaryButton>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = isEn ? "Submit integration request" : "Prijavite partnersku integraciju";
  let t7;
  if ($[10] !== t6) {
    t7 = <SecondaryButton href="#contact">{t6}</SecondaryButton>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="mt-6 flex flex-wrap gap-3">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== flowTitle) {
    t9 = <p className="text-xs font-semibold uppercase tracking-wider text-cadrino-accent">{flowTitle}</p>;
    $[15] = flowTitle;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== flowSteps) {
    t10 = <div className="mt-3 grid gap-2 sm:grid-cols-[1fr_auto_1fr_auto_1fr] sm:items-center">{flowSteps.map((step, index) => <div key={step} className="contents"><span className="inline-flex items-center gap-2 rounded-xl border border-white/[0.12] bg-white/[0.04] px-3 py-2 text-xs font-medium text-slate-200"><Database className="h-3.5 w-3.5 text-cadrino-primary" />{step}</span>{index < flowSteps.length - 1 && <ArrowRight className="hidden h-3.5 w-3.5 text-cadrino-muted sm:block" aria-hidden={true} />}</div>)}</div>;
    $[17] = flowSteps;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className="mt-6 rounded-2xl border border-white/[0.12] bg-white/[0.03] p-4">{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== outcomeLine) {
    t12 = <p className="mt-4 text-sm font-medium text-slate-300">{outcomeLine}</p>;
    $[22] = outcomeLine;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== chips) {
    t13 = <div className="mt-6 flex flex-wrap gap-2.5">{chips.map(_temp)}</div>;
    $[24] = chips;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t2 || $[30] !== t3 || $[31] !== t8) {
    t14 = <section className="border-b border-white/[0.08] bg-cadrino-surface/25 py-10"><Container><MotionBlock><div className="rounded-3xl border border-white/[0.12] bg-gradient-to-br from-white/[0.06] to-white/[0.02] p-6 shadow-sm sm:p-8">{t2}{t3}{t8}{t11}{t12}{t13}</div></MotionBlock></Container></section>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t2;
    $[30] = t3;
    $[31] = t8;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}
function _temp(chip) {
  const Icon = chip.icon;
  return <span key={chip.label} className="inline-flex items-center gap-1.5 rounded-full border border-white/[0.1] bg-white/[0.04] px-3 py-1.5 text-xs text-slate-300"><Icon className="h-3.5 w-3.5 text-cadrino-primary" />{chip.label}</span>;
}